// Projekt anfragen: Mehrfachauswahl kommt als eine Zeile in der E-Mail an (ohne Skript jede Auswahl einzeln),
// das Feld für die jetzige Adresse erscheint nur bei „Bestehende Website erneuern“.
(() => {
  const init = (root) => {
    if (root.__anf) return;
    root.__anf = true;
    root.querySelectorAll('[data-anf-gruppe]').forEach((gruppe) => {
      const boxen = [...gruppe.querySelectorAll('input[type="checkbox"]')];
      const zeile = Object.assign(document.createElement('input'), { type: 'hidden', name: `contact[${gruppe.dataset.anfGruppe}]` });
      gruppe.append(zeile);
      const sync = () => (zeile.value = boxen.filter((b) => b.checked).map((b) => b.dataset.wert).join(', '));
      boxen.forEach((b) => {
        b.removeAttribute('name');
        b.addEventListener('change', sync);
      });
      sync();
    });
    // Beispielvideo nur mit Bewegung, sonst bleibt das Standbild
    const video = root.querySelector('[data-anf-video]');
    if (video && document.documentElement.classList.contains('motion')) video.play().catch(() => {});
    root.querySelectorAll('[data-anf-wenn]').forEach((feld) => {
      const [name, wert] = feld.dataset.anfWenn.split('=');
      const zeigen = () => (feld.hidden = root.querySelector(`input[name="${name}"]:checked`)?.value !== wert);
      root.addEventListener('change', zeigen);
      zeigen();
    });
  };
  const start = (scope) => scope.querySelectorAll('[data-anfrage]').forEach(init);
  document.addEventListener('shopify:section:load', (e) => start(e.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(document));
  else start(document);
})();
